import { render, staticRenderFns } from "./WsRequestExamTypeFormItem.vue?vue&type=template&id=3aa9288a"
import script from "./WsRequestExamTypeFormItem.vue?vue&type=script&lang=js"
export * from "./WsRequestExamTypeFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports